<template>
  <div class="component-additional-services additional-services">
    <Headline :value="headline" :number="`${data.sectionNumber}`" />
    <div v-if="offer" class="additional-services--row">
      <Service v-for="service in services" :key="service.Code"
        :value="service" :offer="offer" />
    </div>
  </div>
</template>

<script>
import sortBy from 'lodash/sortBy'
import Vue from 'vue'
import Component from 'vue-class-component'
import { mapGetters } from 'vuex'

import Service from '@/components/booking/additionalServices/Service'
import Headline from '@/components/forms/Headline'
import Store from '@/store/index'
import MediaDetector from '@/utils/MediaDetector'

@Component({
  store: Store,
  mixins: [
    MediaDetector,
  ],
  components: {
    Headline,
    Service,
  },
  props: {
    data: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      offer: 'Booking/getOffer',
    }),
  },
})
export default class AdditionalServices extends Vue {
  services = sortBy(this.data.additionalServices, [ 'Code' ])

  // This should be fully done with new SC field
  get headline () {
    return this.isMobile ? 'Dodaj usługi dodatkowe' : this.data.headline
  }
}
</script>

<style lang="scss" scoped>
.additional-services {
  display: grid;
  grid-template-columns: 1fr;
  padding: 20px;

  @include mediaFluid(tablet) {
    padding: 20px 0;
  }

  &--row {
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: 20px;
    max-width: 900px;

    @include mediaFluid(tablet) {
      grid-template-columns: repeat(3, 1fr);
      grid-column-gap: 18px;

    }
    @include mediaFluid(desktop) {
      grid-column-gap: 20px;
    }
  }
}
</style>

<style lang="scss">
.additional-services {
  .modal-dialog:not(.modal-dialog--small) .modal-dialog__wrapper {
    max-width: 1050px;
    padding: 0;

    @include mediaFluid(tablet) {
      padding: 0 10px;
    }

    .modal-header {
      padding: 0 20px;

      @include mediaFluid(tablet) {
        padding: 0;
      }

      &__title {
        font-size: 22px;

        @include mediaFluid(tablet) {
          font-size: 1.7em;
        }
      }
    }
  }

  .modal-header__title {
    font-size: 1.7em;
    font-weight: bold;
  }

  .modal-header__titles hr {
    display: none;
  }

  .modal-dialog--close {
    cursor: pointer;
  }

  .headline {
    font-family: 'Gotham Book';

    span {
      line-height: 1.2;
      font-size: 1.3em;
      font-weight: bold;

      @include media(tablet) {
        line-height: 1;
        font-size: 22px;
        font-weight: lighter;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/booking/AdditionalServices.vue